import axios from 'axios';

const API_URL = 'http://dev.ouicsport.fr/api/profile';

export const uploadProfileImage = (userId, file) => {
  const formData = new FormData();
  formData.append('userId', userId);
  formData.append('file', file);

  return axios.post(`${API_URL}/upload-photo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const deleteProfilePhoto = (userId) => {
  const formData = new FormData();
  formData.append('userId', userId);

  return axios.post(`${API_URL}/delete-photo`, formData);
};

export const updateProfile = (userData) => {
  const formData = new FormData();
  for (const key in userData) {
    formData.append(key, userData[key]);
  }

  return axios.post(`${API_URL}/update`, formData);
};

export const rechargeCredits = (userId, amount, paymentIntentId) => {
  const formData = new FormData();
  formData.append('userId', userId);
  formData.append('amount', amount);
  formData.append('paymentIntentId', paymentIntentId);

  return axios.post(`${API_URL}/recharge-credits`, formData);
};

export const fetchCreditsBalance = (userId) => {
  return axios.get(`${API_URL}/credits-balance`, {
    params: { userId }
  });
};

export const fetchSportsAndTypes = () => {
  return axios.get(`${API_URL}/sports-types-list`);
};
